import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageModel } from '../../../hooks';
import styles from './style/index.less';
var RobotAnswers = function (props) {
    var answers = props.answers, disabled = props.disabled;
    var View = useComponents().View;
    var _a = useState(-1), activeAnswer = _a[0], setActiveAnswer = _a[1];
    var messageModel = useMessageModel();
    var handleAnswerClick = function (a, index) {
        setActiveAnswer(index);
        messageModel.sendMessage(a, { inputType: 'click' });
    };
    return (React.createElement(View, { className: styles['server-answer'] + " " + styles['server-answer-container'] }, answers.map(function (a, index) { return (React.createElement(View, { key: index, onClick: function () { return handleAnswerClick(a, index); }, className: styles['server-answer-item'] + " " + (activeAnswer === index ? styles['server-answer-item-selected'] : '') + " " + (disabled || activeAnswer !== -1 ? styles['server-answer-item-disabled'] : '') }, a)); })));
};
export default RobotAnswers;
